// Constants shared by the app API (server/) and the React app (client/).

/** Request header the browser client sends to get superjson bodies. */
export const ENCODING_HEADER = 'x-aranx-encoding';
export const SUPERJSON_ENCODING = 'superjson';

/** Response header with the operation's access: read, write, or danger. */
export const ACCESS_HEADER = 'x-aranx-operation-access';

export const API_BASE_PATH = '/api/v1';
